import styled from '@emotion/styled';
import rem from '../../../utils/rem/rem';

export const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0 ${rem(32)};
`;

export const InputWrapperSmall = styled.div`
  width: ${rem(80)};
`;

export const InputWrapperMedium = styled.div`
  width: ${rem(150)};
`;

export const InputWrapperLarge = styled.div`
  width: ${rem(700)};
`;

export const TextAreaWrapper = styled.div`
  width: ${rem(700)};
`;